<template>
  <div class="col-xl-5 mx-auto">
    <p v-if="!submissions.length">You don't have any submissions. Click "New NJCRIB ERM-14 Form" to start one.</p>
    <div v-else>
    <h5>My <b>NJCRIB ERM-14</b> Forms</h5>
    <b-table striped :items="submissions" :fields="fields" class="table-light">
      <template v-slot:cell(actions)="data">
        <b-button
          :to="{ name: 'change/list', params: { submissionId: data.item.submissionID }}"
          size="sm"
          variant="success">{{ canEdit(data.item.statusID) ? 'Edit' : 'View' }}</b-button>
        <b-button @click.prevent.stop="deleteClicked(data.item.submissionID)" variant="danger" size="sm" class="ml-1" v-if="canDelete(data.item.statusID)">Delete</b-button>
      </template>
    </b-table>
    </div>

    <b-modal ref="delete-modal" title="Are you sure?" header-text-variant="dark" body-text-variant="dark" centered>
      <template slot="default">
        Are you sure you want to delete this submission?
      </template>
      <template slot="modal-footer" class="float-right">
        <b-button variant="danger" @click.prevent="deleteSubmission" :disabled="isDeleting">
          <span v-if="!isDeleting">Delete</span>
          <span v-else><b-spinner small></b-spinner> Please Wait...</span>
        </b-button>
        <b-button variant="secondary" @click.prevent="cancelClicked">Cancel</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'submission-search',
  data() {
    return {
      fields: [
        { key: 'submissionID' , label: 'ID', sortable: true },
        { key: 'statusID' , label: 'Status', sortable: true, formatter: this.submissionStatusFormatter },
        { key: 'created' , label: 'Created', sortable: true, formatter: this.DateFormatter },
        { key: 'lastUpdated' , label: 'Last Updated', sortable: true, formatter: this.DateFormatter },
        { key: 'actions', label: '', sortable: false, class: ['action-buttons'] }
      ],
      submissionIdToDelete: '',
      isDeleting: false
    }
  },
  computed: {
    ...mapGetters({
      submittedStatusID: 'application/submittedStatusID',
      submittedToSpectrumStatusID: 'application/submittedToSpectrumStatusID',
      notSubmittedStatusID: 'application/notSubmittedStatusID',
      returnedStatusID: 'application/returnedStatusID'
    }),
    submissions() {
       return this.$store.state.submission.submissions.slice().sort((a, b) => b.submissionID - a.submissionID)
    }
  },
  methods: {
    submissionStatusFormatter(value, key, item) {
      return value == this.submittedToSpectrumStatusID ? 'Submitted' : item.status
    },
    canDelete(statusId) {
      return this.notSubmittedStatusID == statusId
    },
    canEdit(statusId) {
      return this.notSubmittedStatusID == statusId || this.returnedStatusID == statusId
    },
    deleteClicked(id) {
      this.$refs['delete-modal'].show()
      this.submissionIdToDelete = id
    },
    cancelClicked() {
      this.$refs['delete-modal'].hide()
      this.submissionIdToDelete = ''
    },
    deleteSubmission() {
      this.isDeleting = true
      this.$store.dispatch('submission/delete', this.submissionIdToDelete).then(() => {
        this.isDeleting = false
        this.$refs['delete-modal'].hide()
        this.submissionIdToDelete = ''
      }).catch(() => {
        this.isDeleting = false
      })
    }
  }
}
</script>